import { PermissionModeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/permission-gps.enum';
import { BusinessPartnerBySubRoute } from '../../../interfaces/busines-partner-by-sub-route.interface';

export interface BulkGpsUpdateDialogData {
  subRouteId: string;
  subRouteName: string;
  /** Route company Mongo `_id` — scopes the partner list to the sub-route's company. */
  companyId?: string | null;
}

export enum BulkGpsUpdateStep {
  CONFIGURE = 'configure',
  CONFIRM = 'confirm',
  RESULTS = 'results',
}

export interface BulkGpsUpdatePayload {
  subRouteId: string;
  businessPartnerIds: string[];
  useGps: boolean;
  useGpsMode: PermissionModeEnum;
  distanceBtwSellerAndCustomer: number;
}

export interface BulkGpsUpdateResultItem {
  businessPartnerId: string;
  code: string;
  name: string;
  success: boolean;
  message?: string;
}

export interface BulkGpsUpdateResult {
  total: number;
  successCount: number;
  failedCount: number;
  items: BulkGpsUpdateResultItem[];
}

export type BulkGpsUpdateDialogCloseResult =
  | { refreshed: boolean }
  | undefined;

export interface BulkGpsPartnerRow extends BusinessPartnerBySubRoute {}
